import facetsGroup from 'components/facets-group.vue';
import productSuggest from 'components/product/product-suggest.vue';
import productBodyShapes from 'components/product/product-body-shapes';

Vue.component('facets-group', facetsGroup);
Vue.component('product-suggest', productSuggest);
Vue.component('product-body-shapes', productBodyShapes);

new Vue({
    el: '#suggested-products-block',
});

new Vue({
    el: '#category-filters',
});

new Vue({
    el: '#body-shapes',
});
